var initSliders = function initSliders() {
  new Swiper('.topbar__slider', {
    loop: true,
    effect: 'fade',
    grabCursor: true,
    autoplay: {
      delay: 5000
    }
  });
  new Swiper('.tags__slider', {
    spaceBetween: 12,
    slidesPerView: 'auto'
  });
  new Swiper('.reviews-slider__slider', {
    loop: true,
    effect: 'fade',
    grabCursor: true,
    autoplay: {
      delay: 2500
    },
    pagination: {
      el: '.reviews-slider__pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.reviews-slider__button-next',
      prevEl: '.reviews-slider__button-prev'
    }
  });
  new Swiper('.icon-cards__slider', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: false,
    pagination: {
      el: '.icon-cards__pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: 3
      },
      1200: {
        spaceBetween: 20,
        slidesPerView: 5
      }
    }
  });
  new Swiper('.services-slider__slider', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: false,
    navigation: {
      nextEl: '.services-slider__button-next',
      prevEl: '.services-slider__button-prev'
    },
    pagination: {
      el: '.services-slider__pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        spaceBetween: 30,
        slidesPerView: 3
      }
    }
  });
  new Swiper('.gallery-slider__slider', {
    slidesPerView: 'auto',
    initialSlide: 1,
    spaceBetween: 15,
    grabCursor: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.gallery-slider__button-next',
      prevEl: '.gallery-slider__button-prev'
    },
    pagination: {
      el: '.gallery-slider__pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        centeredSlides: false,
        initialSlide: 0
      },
      1200: {
        slidesPerView: 'auto',
        centeredSlides: false,
        initialSlide: 0
      },
      1900: {
        slidesPerView: 'auto',
        centeredSlides: false,
        initialSlide: 0
      }
    }
  });
  new Swiper('.posts-slider__slider', {
    slidesPerView: 'auto',
    spaceBetween: 15,
    loop: false,
    navigation: {
      nextEl: '.posts-slider__button-next',
      prevEl: '.posts-slider__button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        spaceBetween: 30,
        slidesPerView: 3
      }
    }
  });
  new Swiper('.highlight-slider__slider', {
    slidesPerView: 1.5,
    spaceBetween: 15,
    initialSlide: 1,
    centeredSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 0,
        initialSlide: 0
      }
    }
  });
  new Swiper('.featured-industries__slider', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    centeredSlides: false,
    navigation: {
      nextEl: '.featured-industries__button-next',
      prevEl: '.featured-industries__button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        spaceBetween: 30,
        slidesPerView: 3
      }
    }
  });
  new Swiper('.related-posts__slider', {
    slidesPerView: 'auto',
    spaceBetween: 15,
    navigation: {
      nextEl: '.related-posts__button-next',
      prevEl: '.related-posts__button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3
      },
      1024: {
        spaceBetween: 30,
        slidesPerView: 3
      }
    }
  });
};
export { initSliders };